exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".columnfun[data-v-2ee69c61]{width:calc(100% - 30px);max-width:1200px;margin:0 auto}", ""]);

// exports
